import { computed } from "vue";
import Flipper from "@/modules/flipper";
import { useMonitorSize } from "./monitor_size";

export function usePhotoEditor() {
  const { isSmallTablet } = useMonitorSize();
  const isNewEditorEnabled = computed(() => Flipper.isEnabled("new_photo_editor") && !isSmallTablet.value);

  return {
    isNewEditorEnabled,
  };
}
